import SkeletonComponent from '@atoms/SkeletonComponent';
import { Text } from '@components/primitives';
import AccountSelector from '@molecules/AccountSelector';
import AccountSlider from '@molecules/AccountSlider';
import appStyles from '@root/appStyles';
import { getStore } from '@store/storeUtils';
import { AMPLITUDE_EVENT_SOURCES } from '@utils/analytics/constants';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import styles from './styles';

interface Props {
  isLoading?: boolean;
}

const WithdrawlSlider: React.FC<Props> = ({ isLoading = false }) => {
  const { t } = useTranslation('common');
  const { selectedAccount, withdrawlAccounts, setSelectedAccount, meAmplitudeContext } = getStore();

  const accounSelectorProps = {
    selectedAccount,
    withdrawlAccounts,
    setSelectedAccount,
    homePage: true,
  };
  const elevation = { elevation: 8 };
  if (isLoading) {
    return <SkeletonComponent />;
  }
  return (
    <View style={[appStyles.borderWithShadow, elevation]}>
      <View style={styles.withdrawlHeader}>
        <Text testID="txtWithdrawlSliderHeading" variant="sm-normal" flex={1}>
          {t('withdrawlSlider.heading')}
        </Text>
        <AccountSelector
          {...accounSelectorProps}
          source={AMPLITUDE_EVENT_SOURCES.home_page}
          meAmplitudeContext={meAmplitudeContext}
        />
      </View>
      <AccountSlider />
    </View>
  );
};

export default WithdrawlSlider;
